import { roleAction } from './user/roleAction';
import { monHocAction } from './category/monHocAction';
import { heAction } from './category/heAction';
import { khoiAction } from './category/khoiAction';
import { truongAction } from './category/truongAction';
import { authActions } from "./auth/authActions";
import { loginActions } from "./auth/loginActions";
import { subSytemActions } from "./sub-sytem/subSystemAction";
import { userActions } from "./user/userAction";
import { appConfigAction } from './common/appConfigActionType';
import { venderAction } from './user/venderAction';

export const actions = {
    login: loginActions,
    auth: authActions,
    user: userActions,
    subSystem: subSytemActions,
    truong: truongAction,
    khoi: khoiAction,
    he: heAction,
    monHoc: monHocAction,
    role: roleAction,
    appConfig: appConfigAction,
    vender: venderAction

}